<template>
    <div v-route-title="'数据管理'">
        <div class="main_left">
            <div class="menu_left22" style="width: 100%;">
                <h5 class="menu_title">数据管理</h5>
                <div class="project-list" v-if="tree">
                    <el-tree ref="tree" node-key="id" :current-node-key="currentNodeKey" highlight-current
                             class="yq-portal-tree" :data="tree" :props="treeProps" default-expand-all
                             @current-change="onCurrentChange">
                    <span class="yq-portal-tree-node" slot-scope="{ node, data }">
                        <span class="yq-portal-tree-node-left">
                            <i :class="{
                            'el-icon-folder-opened': data.type==='folder' && node.expanded,
                            'el-icon-folder': data.type==='folder' && !node.expanded,
                            'el-icon-tickets': data.type!=='folder'
                            }"></i>
                            <span>{{ node.label }}</span>
                        </span>
                    </span>
                    </el-tree>
                </div>
            </div>
        </div>
        <div class="main_right33">
            <data-admin-news-list v-if="currentDatasource" :datasource-id="currentDatasource.id"></data-admin-news-list>
            <news-section-edit-list v-if="currentSection" :section-id="currentSection.id"></news-section-edit-list>
        </div>
    </div>
</template>

<script>
    import datasourceConfigService from '../service/datasource-config'
    import sectionService from '../service/section'
    import DataAdminNewsList from '../components/common/DataAdminNewsList'
    import NewsSectionEditList from "../components/common/NewsSectionEditList";
    import {mapGetters, mapState} from 'vuex'

    export default {
        name: "DataAdmin",
        components: {DataAdminNewsList, NewsSectionEditList},
        data(){
            return {
                portal: null,
                tree: null,
                treeProps: {
                    children: 'children',
                    label: 'label'
                },
                currentNodeKey: null,
                currentDatasource: null,
                currentSection: null
            }
        },
        computed: {
            ...mapState(['user']),
            ...mapGetters(['hasAuthority', 'hasAnyAuthority']),
        },
        created(){
            this.init()
        },
        methods: {
            async init(){
                const response = await datasourceConfigService.listDatasourceConfigs({
                    editableToUser: this.user.id,
                    page: 0,
                    size: 1000
                })
                const datasources = response.data.content.map(datasource => {
                    return {
                        id: 'ds'+datasource.id,
                        type: 'ds',
                        datasource: datasource,
                        label: datasource.name
                    }
                })
                const sections = (await sectionService.listSections({
                    type: 'news',
                    editNotifyData: true,
                    page: 0,
                    size: 1000
                })).data.content
                this.tree = [
                    {
                        id: 'ds',
                        label: '数据源',
                        type: 'folder',
                        children: datasources
                    },
                    {
                        id: 'section',
                        label: '推送栏目',
                        type: 'folder',
                        children: sections.map(section => {
                            return {
                                id: 'section'+section.id,
                                type: 'section',
                                section: section,
                                label: section.name
                            }
                        })
                    }
                ]
                if(datasources.length>0){
                    this.currentNodeKey = datasources[0].id
                    this.onCurrentChange(datasources[0])
                }
            },
            async onCurrentChange(data){
                this.currentNodeKey = data.id
                if(data.type === 'folder'){
                    return
                }
                if(data.type === 'ds'){
                    this.currentSection = null
                    this.currentDatasource = data.datasource
                }else if(data.type === 'section'){
                    this.currentDatasource = null
                    this.currentSection = data.section
                }
            }
        }
    }
</script>

<style scoped>
</style>
